import React, { useState, useEffect, useContext } from "react";

import { Box, IconButton, Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Typography, Stack, Button } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { completeMessage, getRuta, isAccess, simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import NoData from "../../../components/NoData";
import { PaginationComponent } from "../../../components/PaginationComponent";
import SmallModal from "../../../components/modals/SmallModal";

import Swal from "sweetalert2";
import { deletePeriodicidadAsync, getPeriodicidadListAsync } from "../../../api/Periodicidad";
import AddPeriodicidad from "./AddPeriodicidad";
import EditPeriodicidad from "./EditPeriodicidad";
import { useNavigate } from "react-router-dom";
import { monoFont } from "../../../theme";

const PeriodicidadList = () => {
  const [periodicidadList, setPeriodicidadList] = useState([]);
  const [selectedPeriodicidad, setSelectedPeriodicidad] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const { reload, setReload, access, setIsLoading, setIsLogged, setIsUnautorized } = useContext(DataContext);

  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getPeriodicidadListAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setPeriodicidadList(result.data.result);
    })();
  }, [reload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = periodicidadList.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const deletePeriodicidad = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await deletePeriodicidadAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);

            if (result.error === "eX01") {
              deleteUserData();
              deleteToken();
              setIsLogged(false);
              return;
            }

            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            completeMessage("No se pudo eliminar", result.error, "error");
            return;
          }

          setIsLoading(false);
          setReload(!reload);
          Swal.fire("Eliminado!", "Periodicidad eliminada.", "success");
        })();
      }
    });
  };

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: "1px solid", borderColor: "divider" }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Periodicidad de pago</Typography>
          {isAccess(access, "CONFIG CREATE") ? (
            <Button onClick={() => setShowModal(true)} variant="contained" color="primary" size="small" startIcon={<AddRoundedIcon sx={{ fontSize: 17 }} />}>
              Agregar
            </Button>
          ) : null}
        </Box>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <Stack spacing={0}>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table size="small" sx={{ minWidth: 560 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell align="center">Días de cuota</TableCell>
                    <TableCell align="center">Plazos</TableCell>
                    {isAccess(access, "CONFIG UPDATE") || isAccess(access, "CONFIG DELETE") ? <TableCell align="center">Acciones</TableCell> : null}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentItem.map((row) => {
                    const { id, description, cuotaDias, countPlazos } = row;
                    return (
                      <TableRow key={id}>
                        <TableCell sx={{ fontFamily: monoFont, color: "text.disabled" }}>{id}</TableCell>
                        <TableCell sx={{ fontWeight: 500 }}>{description}</TableCell>
                        <TableCell align="center" sx={{ fontFamily: monoFont }}>
                          {cuotaDias}
                        </TableCell>
                        <TableCell align="center">
                          <Stack direction={"row"} spacing={1} justifyContent="center" alignItems={"center"}>
                            <Box component="span" sx={{ fontFamily: monoFont }}>
                              {countPlazos}
                            </Box>
                            <IconButton size="small" onClick={() => navigate(`${ruta}/plazosbyperiodicidadid/${id}`)}>
                              <OpenInNewRoundedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </Stack>
                        </TableCell>
                        {isAccess(access, "CONFIG UPDATE") || isAccess(access, "CONFIG DELETE") ? (
                          <TableCell align="center">
                            <Stack direction={"row"} spacing={0.5} justifyContent="center">
                              {isAccess(access, "CONFIG UPDATE") ? (
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setSelectedPeriodicidad(row);
                                    setShowEditModal(true);
                                  }}
                                >
                                  <EditRoundedIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                              ) : null}
                              {isAccess(access, "CONFIG DELETE") ? (
                                <IconButton size="small" sx={{ color: "error.main" }} onClick={() => deletePeriodicidad(row)}>
                                  <DeleteRoundedIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                              ) : null}
                            </Stack>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ padding: "10px 20px 14px" }}>
              <PaginationComponent data={periodicidadList} paginate={paginate} itemsperPage={itemsperPage} />
            </Box>
          </Stack>
        )}
      </Paper>

      <SmallModal titulo={"Agregar Periodicidad"} isVisible={showModal} setVisible={setShowModal}>
        <AddPeriodicidad setShowModal={setShowModal} />
      </SmallModal>

      <SmallModal titulo={`Editar: ${selectedPeriodicidad.description}`} isVisible={showEditModal} setVisible={setShowEditModal}>
        <EditPeriodicidad selected={selectedPeriodicidad} setShowModal={setShowEditModal} />
      </SmallModal>
    </div>
  );
};

export default PeriodicidadList;
